/* prettier-ignore */

import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from'sweetalert2';

@Component({
  selector: 'header-tech-logout',
  templateUrl: './tech-exit.component.html',
  styleUrl: './tech-exit.component.scss',
})

export class HeaderTechExitComponent {

    constructor(
        public translate: TranslateService,
    ) {}

    exitTechMode(){
        Swal.fire({
            title: this.translate.instant(`¿Quieres salir del modo edición?`),
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: "#ff0000",
            cancelButtonColor: "#000000",
            confirmButtonText: this.translate.instant("Cerrar sesión"),
            cancelButtonText: this.translate.instant(`Cancelar`),
            reverseButtons: true,
            scrollbarPadding: false
        }).then((result) => {
            if (result.isConfirmed){
                localStorage.removeItem('techMode');
                location.reload();
            }
        });
    }

}